/**
 * Ordered section ids for the manual order creation drawer — single source of truth consumed by
 * both `OrderCreationDrawer` (section list + i18n keys) and its tests. Each id is camelCase so it
 * doubles as the `sections.<id>` i18n key segment with no derivation step.
 */
export const ORDER_CREATION_SECTION_IDS = [
  'generalInformation',
  'customer',
  'routeInformation',
  'content',
  'scheduling',
] as const;

export type OrderCreationSectionId = (typeof ORDER_CREATION_SECTION_IDS)[number];

// Single source for each individual id — consumed by the drawer and `useSubmitOrder` instead of
// each re-destructuring `ORDER_CREATION_SECTION_IDS` locally.
export const [
  GENERAL_INFORMATION_SECTION_ID,
  CUSTOMER_SECTION_ID,
  ROUTE_INFORMATION_SECTION_ID,
  CONTENT_SECTION_ID,
  SCHEDULING_SECTION_ID,
] = ORDER_CREATION_SECTION_IDS;
